import {Box, Grid, Typography, UnstableCard as Paper} from '@yandex-delivery/blocks'
import type {ReactElement} from 'react'

import {tagToUrl} from '../../lib/createTagToUrl'
import {renderWidget} from '../../widgets/index@desktop'
import {BusinessBanner} from '../BusinessBanner/index@desktop'
import {type SectionProps as Props} from '../types'
import * as classes from './Verticals@desktop.classes'

export function VerticalsDesktop(props: Props): ReactElement {
  const section = props.section
  const widgets = section.widgets.filter(widget => widget.type !== 'slot' && widget.type !== 'divider')
  const hasBusinessBanner = section.widgets.some(
    widget =>
      widget.type === 'slot' &&
      widget.widget_id !== 'cargo_c2c_order_forms_b2b_lk_cargo_business_banner_information_slot_widget',
  )
  const hasVerticals = section.widgets.some(
    widget => widget.widget_id === 'cargo_c2c_order_forms_b2b_lk_cargo_verticals_widget',
  )

  return (
    <>
      {!hasBusinessBanner && !hasVerticals ? null : (
        <Grid xs={12} item>
          <Paper padding="M" radius="L">
            <Grid container>
              <Grid xs={12} item>
                <Box className={classes.wrapper.header}>
                  <div className={classes.wrapper.logo}>
                    <img alt="" className={classes.logo} loading="lazy" src={tagToUrl('delivery_box_icon')} />
                  </div>
                  <Typography thickness="medium" variant="title4">
                    Заказать
                  </Typography>
                </Box>
              </Grid>

              {widgets.map((widget, index) => {
                return (
                  <div key={index} className={classes.wrapper.block}>
                    {renderWidget(widget)}
                  </div>
                )
              })}
            </Grid>
            {hasBusinessBanner && <BusinessBanner {...props} />}
          </Paper>
        </Grid>
      )}
    </>
  )
}
